var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "shape-hero-curved-bottom",
  "use": "shape-hero-curved-bottom-usage",
  "viewBox": "0 0 1220 232",
  "content": "<symbol viewBox=\"0 0 1220 232\" id=\"shape-hero-curved-bottom\"><path d=\"M2 0c.023 41 33.202 99.334 144.479 99.334 105.983 0 149.093-43.692 222.822-43.692 127.01 0 213.028 135.956 396.451 135.956C917.192 191.598 1093.57 99.047 1218 8h2v224H0V0h2\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-sprite/shape-hero-curved-bottom.svg
// module id = 181
// module chunks = 35783957827783 114276838955818